import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import React from 'react';

type EmailMetaTextProps = {
    text: string;
};

const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: 13,
        color: '#adb5bd',
        marginTop: theme.spacing(1.5),
    },
}));

const EmailMetaText: React.FC<EmailMetaTextProps> = ({ text }) => {
    const classes = useStyles();
    return <Typography className={classes.root}>{text}</Typography>;
};

export default EmailMetaText;
